<datex-list [items]="items"
            [pageSize]="pageSize"
            [(pageSkip)]="pageSkip"
            [totalCount]="totalCount"
            [loadingStatus]="loadingStatus"
            (loadMore)="$dataLoad()">

  <ng-container topToolbar>
  </ng-container>


  <ng-template listItemDef
               let-item>
    <FootprintManager-dock_appoinment_activity_card
    [dockAppointmentId]="item.$content_FootprintManager_dock_appoinment_activity_card_inParams_dockAppointmentId"
    [activityDetails]="item.$content_FootprintManager_dock_appoinment_activity_card_inParams_activityDetails"
    [activityDate]="item.$content_FootprintManager_dock_appoinment_activity_card_inParams_activityDate"
    [activityUser]="item.$content_FootprintManager_dock_appoinment_activity_card_inParams_activityUser"
    [style]="item.$content_FootprintManager_dock_appoinment_activity_card_inParams_style"
    [title]="item.$content_FootprintManager_dock_appoinment_activity_card_inParams_title"
    ($refreshEvent)="$refreshEvent.emit()"
    >
    </FootprintManager-dock_appoinment_activity_card>
  </ng-template>

</datex-list>